import { render, staticRenderFns } from "./ComponentTasks.vue?vue&type=template&id=370e6a56&scoped=true&"
import script from "./ComponentTasks.vue?vue&type=script&lang=js&"
export * from "./ComponentTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e6a56",
  null
  
)

export default component.exports